/**
 * Created by fruysshaert on 23/03/2017.
 */

export class BrowseConfigProspect {
    public categorieProspect?: string;
    public nomProspect?: string;
    public prenomProspect?: string;
    public dateNaissanceProspect?: string;
    public lieuNaissanceProspect?: string;
    public raisonSocialeProspect?: string;
    public sirenProspect?: string;
    public dateCreationEntrepriseProspect?: string;
    public adresseMailProspect?: string;
    public telephoneProspect?: string;
}

export class BrowseConfigClass extends BrowseConfigProspect {
    public typeParcours?: string;
    public typeAction?: string;
    public idCommande?: number;
    public urlCallBack?: string;
    public typeVisiteur?: string;
    public idPanierRCBT?: string;
    public matricule?: string;
    public idDevice?: string;
    public debug?: string;
    public montantPanierRCBT?: string;
    public urlMaintienSession?: string;
    public idContrat?: number;
    // Pandora
    public folderId?: string;
    public status?: string;
    public emailSent?: string;
    public emailValue?: string;
}
